/**
 * Whether to offer the WhatsApp "The Clippers" community modal.
 *
 * It is no longer a hard gate — it is a dismissible prompt shown only to
 * clipping-channel users (objective `other_channels`) who have not yet joined
 * and have not dismissed it. Content creators (`own_brand`) never see it.
 * Course routes defer the prompt until the user navigates elsewhere.
 *
 * Profile-completion / onboarding precedence is enforced by the caller.
 */
export function shouldShowCommunityModal({
  objective,
  joinedCommunity,
  dismissed,
  pathname,
}: {
  objective: string | null | undefined;
  joinedCommunity: boolean;
  dismissed: boolean;
  pathname: string;
}): boolean {
  return !pathname.startsWith('/courses/')
    && objective === 'other_channels'
    && !joinedCommunity
    && !dismissed;
}
